import React, { ChangeEvent, FC, useState } from 'react';
import { ContentWrapperWidget, MainTemplate } from '../../components/layouts';
import { useClassifierByIdQuery } from '../../api';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  withStyles,
} from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { blue } from '@material-ui/core/colors';
import MainInfo from '../../components/widgets/Classifiers/MainInfo';
import ClassifierValuesWidget from '../../components/widgets/Classifiers/ClassifierValues';

type AccordionTypes = 'MainInfo' | 'ClassifierValues' | undefined;

const AccordionSummary = withStyles({
  root: {
    backgroundColor: blue[700],
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: 'white',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

// @TODO: Update View for Dialog request to Archive

const Single: FC<{}> = () => {
  const {
    params: { id },
  } = useRouteMatch();
  // const [page, setPage] = useState<number>(0);
  const [expanded, setExpanded] = useState<AccordionTypes>('MainInfo');

  // const access = usePermission('directory', 'person');
  // const style = useStyle();
  // const canAdd = true;
  const { data } = useClassifierByIdQuery({ variables: { id } });

  const handleChangeAccordion = (panel: AccordionTypes) => (event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : undefined);
  };

  return (
    <MainTemplate pageName="" url="">
      <ContentWrapperWidget>
        {id === 'new' ? <h2>Добавить новый классификатор</h2> : <h2>Классификатор: {data?.classifier?.name}</h2>}
        <Accordion expanded={expanded === 'MainInfo'} onChange={handleChangeAccordion('MainInfo')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Основная информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MainInfo id={id} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'ClassifierValues'}
          onChange={handleChangeAccordion('ClassifierValues')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Значения классификатора</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ClassifierValuesWidget id={id} />
          </AccordionDetails>
        </Accordion>
      </ContentWrapperWidget>
    </MainTemplate>
  );
};

export default Single;
